export enum ERR_CODE {
  NOT_UC_CLIENT = 100001,
  SERVER_IS_BUSY = 100002,
  ITEM_ID_NOT_VALID = 100003,
  PARAM_IS_NOT_NUMBER = 100004,
}

// 缓存等级
export enum CacheLevel {
  no_cache = '0',
  memory = '1',
  tair = '2',
}

export enum CacheControl {
  forceCache = 'forceCache',
  forceNoCache = 'forceNoCache',
}

export const cacheControls = [CacheControl.forceCache, CacheControl.forceNoCache];

// 不要在同构代码中使用，会shake不掉
export const isDevNode = !process.env.BROWSER && process.env.NODE_ENV === 'development';

// 不要在同构代码中使用，会shake不掉
export function devConsole(...args) {
  if (isDevNode) {
    console.log.apply(console, args);
  }
}

export function renderSimpleReplace(htmlWithPots: string, data: object) {
  const r = htmlWithPots.replace(/{{\s*(\w+)\s*}}/g, (str, p1, offset, s) => {
    return data[p1];
  });

  // for (const dataKey in data) {
  //   if (data.hasOwnProperty(dataKey)) {
  //     const value = data[dataKey];
  //     r = r.replace(new RegExp(`{{\\s*${dataKey}\\s*}}`, 'g'), value);
  //   }
  // }
  return r;
}
interface IImageReplace {
  from: string;
  to: string;
}
export const imgDomainShareReplacing: IImageReplace[] = [
  {
    from: 'http://hl-img.peco.uodoo.com',
    to: 'http://hl-img.peco.inibaruberita.com',
  },
  {
    from: 'http://img.uodoo.com',
    to: 'http://img.ucweb.com',
  },
];

export const LT_WA_AIR = 'ucfront-page';
export const WA_AIR_APPID = '4ea393c92d74';

export interface IApiWrap<T> {
  status: number;
  message: string;
  data: T;
}
